import React, { useEffect } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import toast from 'react-hot-toast';

const InvoicePopup = ({ isOpen, onClose, orderData }) => {
  // Remove auto-close timer - user must manually close
  // useEffect removed

  if (!isOpen || !orderData) return null;

  const items = orderData.order || [];

  const downloadPDF = async () => {
    const element = document.getElementById('invoice-popup-content');
    if (!element) return;

    try {
      const canvas = await html2canvas(element, { scale: 2, logging: false });
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 210;
      const pageHeight = 295;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      pdf.save(`invoice_${orderData.orderId}.pdf`);
      toast.success("PDF downloaded successfully!");
    } catch (error) {
      console.error("PDF download failed:", error);
      toast.error("Failed to download PDF");
    }
  };

  const printInvoice = () => {
    const printContent = document.getElementById('invoice-popup-content');
    if (!printContent) return;

    const printWindow = window.open('', '_blank', 'width=800,height=600');
    printWindow.document.write(`
      <html>
        <head>
          <title>Invoice ${orderData.orderId}</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            @media print {
              body { padding: 0; }
              button { display: none; }
            }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
          <script>
            window.onload = () => {
              window.print();
              window.onafterprint = () => window.close();
            }
          <\/script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.6)',
      zIndex: 3000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      animation: 'fadeIn 0.3s ease'
    }} onClick={onClose}>
      <div style={{
        backgroundColor: '#fff',
        borderRadius: '20px',
        width: '90%',
        maxWidth: '550px',
        maxHeight: '90vh',
        overflowY: 'auto',
        position: 'relative',
        scrollbarWidth: 'thin',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        animation: 'slideUp 0.3s ease'
      }} onClick={e => e.stopPropagation()}>
        
        <style>
          {`
            @keyframes fadeIn {
              from { opacity: 0; }
              to { opacity: 1; }
            }
            @keyframes slideUp {
              from { 
                transform: translateY(50px);
                opacity: 0;
              }
              to { 
                transform: translateY(0);
                opacity: 1;
              }
            }
          `}
        </style>
        
        {/* Close Button - Always Visible */}
        <button
          onClick={onClose}
          style={{
            position: 'sticky',
            top: '15px',
            right: '15px',
            float: 'right',
            background: '#ee6521',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            zIndex: 20,
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
            margin: '10px',
            transition: 'all 0.2s ease',
            color: '#fff',
            fontWeight: 'bold'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#d55a18';
            e.currentTarget.style.transform = 'scale(1.05)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#ee6521';
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          ✕
        </button>

        <div id="invoice-popup-content" style={{
          padding: '20px 24px 24px 24px',
          backgroundColor: '#fff',
          clear: 'both'
        }}>
         
          {/* Order Info - Bill Details */}
          <div style={{ 
            marginBottom: '20px', 
            fontSize: '12px',
            background: '#f9f9f9',
            padding: '12px',
            borderRadius: '8px'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span style={{ fontWeight: 'bold', color: '#555' }}>Order ID</span>
              <span style={{ color: '#333' }}>#{orderData.orderId}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span style={{ fontWeight: 'bold', color: '#555' }}>Date & Time:</span>
              <span style={{ color: '#333' }}>{orderData.date} | {orderData.time}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span style={{ fontWeight: 'bold', color: '#555' }}>Customer Name:</span>
              <span style={{ color: '#333' }}>{orderData.userName || 'WALK-IN CUSTOMER'}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <span style={{ fontWeight: 'bold', color: '#555' }}>Order Type:</span>
              <span style={{ color: '#333' }}>{orderData.orderTypes || 'TABLE DINE IN'}</span>
            </div>
            {orderData.tableCode && (
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                <span style={{ fontWeight: 'bold', color: '#555' }}>Table No:</span>
                <span style={{ color: '#333' }}>{orderData.tableCode}</span>
              </div>
            )}
          </div>

          {/* Items Table */}
          <table style={{ width: '100%', margin: '15px 0', fontSize: '12px', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f0f0f0', borderBottom: '2px solid #ddd' }}>
                <th style={{ textAlign: 'left', padding: '10px 6px', fontWeight: '600' }}>ITEM</th>
                <th style={{ textAlign: 'center', padding: '10px 6px', fontWeight: '600' }}>QTY</th>
                <th style={{ textAlign: 'right', padding: '10px 6px', fontWeight: '600' }}>PRICE</th>
                <th style={{ textAlign: 'right', padding: '10px 6px', fontWeight: '600' }}>TOTAL</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, idx) => (
                <tr key={idx} style={{ borderBottom: '1px dotted #eee' }}>
                  <td style={{ padding: '10px 6px', textAlign: 'left' }}>
                    {(item.productName || item.name || item.dishName || 'Item').substring(0, 25)}
                    {item.variant && <span style={{ fontSize: '10px', color: '#888', display: 'block' }}>{item.variant}</span>}
                   </td>
                  <td style={{ padding: '10px 6px', textAlign: 'center', fontWeight: '500' }}>{item.quantity || 1}</td>
                  <td style={{ padding: '10px 6px', textAlign: 'right' }}>₹{(item.price || 0).toFixed(2)}</td>
                  <td style={{ padding: '10px 6px', textAlign: 'right', fontWeight: '500' }}>₹{((item.price || 0) * (item.quantity || 1)).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Totals Section */}
          <div style={{ marginTop: '15px', borderTop: '2px solid #ddd', paddingTop: '12px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', fontSize: '12px' }}>
              <span>Subtotal:</span>
              <span>₹{orderData.subTotal?.toFixed(2) || '0.00'}</span>
            </div>
            
            {/* Tax Breakdown - CGST & SGST */}
            {orderData.cgst > 0 && orderData.cgst !== undefined && (
              <>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '11px', color: '#666' }}>
                  <span>CGST ({orderData.cgstRate || 2.5}%):</span>
                  <span>₹{orderData.cgstAmount?.toFixed(2) || (orderData.cgst || ((orderData.subTotal || 0) * (orderData.cgstRate || 2.5) / 100)).toFixed(2)}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '11px', color: '#666' }}>
                  <span>SGST ({orderData.sgstRate || 2.5}%):</span>
                  <span>₹{orderData.sgstAmount?.toFixed(2) || (orderData.sgst || ((orderData.subTotal || 0) * (orderData.sgstRate || 2.5) / 100)).toFixed(2)}</span>
                </div>
              </>
            )}
            
            {/* ✅ SERVICE CHARGES - Only show if applied (>0) */}
            {orderData.serviceCharges && orderData.serviceCharges > 0 && (
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                padding: '6px 0', 
                fontSize: '12px',
                borderTop: '1px dashed #ddd',
                marginTop: '4px',
                paddingTop: '8px'
              }}>
                <span style={{ fontWeight: '500', color: '#555' }}>Service Charges:</span>
                <span style={{ color: '#ee6521', fontWeight: '500' }}>₹{orderData.serviceCharges?.toFixed(2)}</span>
              </div>
            )}
            
            {/* Packing Charges */}
            {orderData.packingCharges > 0 && (
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '11px', color: '#666' }}>
                <span>Packing Charges:</span>
                <span>₹{orderData.packingCharges?.toFixed(2)}</span>
              </div>
            )}
            
            {/* Delivery Charges */}
            {orderData.deliveryCharges > 0 && (
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '11px', color: '#666' }}>
                <span>Delivery Charges:</span>
                <span>₹{orderData.deliveryCharges?.toFixed(2)}</span>
              </div>
            )}
            
            {/* Discount */}
            {orderData.discountAmount > 0 && (
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', fontSize: '12px', color: '#22c55e' }}>
                <span>Discount:</span>
                <span>-₹{orderData.discountAmount?.toFixed(2)}</span>
              </div>
            )}
            
            {/* Grand Total */}
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              padding: '12px 0 8px', 
              fontSize: '18px', 
              fontWeight: 'bold', 
              borderTop: '2px solid #333',
              marginTop: '8px'
            }}>
              <span style={{ color: '#333' }}>TOTAL AMOUNT:</span>
              <span style={{ color: '#ee6521', fontSize: '20px' }}>₹{orderData.totalAmount?.toFixed(2) || '0.00'}</span>
            </div>
            
            {/* Amount in words */}
            <div style={{ fontSize: '9px', color: '#888', marginTop: '8px', fontStyle: 'italic' }}>
              Amount in Words: {orderData.amountInWords || `Rupees ${(orderData.totalAmount || 0).toFixed(2)} Only`}
            </div>
          </div>

          {/* Payment Info */}
          <div style={{ 
            background: '#f5f5f5', 
            padding: '12px', 
            borderRadius: '8px', 
            margin: '15px 0',
            fontSize: '11px'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
              <span style={{ fontWeight: 'bold' }}>💰 Payment Method:</span>
              <span style={{ color: '#333' }}>{orderData.paymentMethod || 'N/A'}</span>
            </div>
            {orderData.transactionId && (
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                <span style={{ fontWeight: 'bold' }}>Transaction ID:</span>
                <span style={{ fontSize: '10px', color: '#666' }}>{orderData.transactionId}</span>
              </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ fontWeight: 'bold' }}>Payment Status:</span>
              <span style={{ color: '#22c55e', fontWeight: 'bold' }}>{orderData.status || 'COMPLETED'} ✓</span>
            </div>
          </div>

          {/* Footer */}
          <div style={{ textAlign: 'center', borderTop: '2px solid #ee6521', paddingTop: '15px', marginTop: '10px' }}>
            <p style={{ fontSize: '11px', color: '#555', margin: '5px 0', fontWeight: '500' }}>
              🍽️ Thank you for dining with us! 🍽️
            </p>
            <p style={{ fontSize: '9px', color: '#999', margin: '5px 0' }}>
              ** This is a computer generated invoice - no signature required **
            </p>
            <p style={{ fontSize: '9px', color: '#aaa', margin: '5px 0' }}>
              Visit Again | We value your feedback
            </p>
            <p style={{ fontSize: '8px', color: '#bbb', margin: '8px 0 0' }}>
              Powered by MAAMAAS
            </p>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{ 
          display: 'flex', 
          gap: '12px', 
          padding: '16px 20px 20px 20px', 
          borderTop: '1px solid #eee', 
          justifyContent: 'center', 
          backgroundColor: '#fff', 
          borderRadius: '0 0 20px 20px',
          position: 'sticky',
          bottom: 0
        }}>
          <button
            onClick={downloadPDF}
            style={{
              padding: '10px 24px',
              backgroundColor: '#22c55e',
              color: '#fff',
              border: 'none',
              borderRadius: '10px',
              cursor: 'pointer',
              fontWeight: '600',
              fontSize: '13px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#16a34a';
              e.currentTarget.style.transform = 'scale(1.02)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#22c55e';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            📄 Download PDF
          </button>
          <button
            onClick={printInvoice}
            style={{
              padding: '10px 24px',
              backgroundColor: '#ee6521',
              color: '#fff',
              border: 'none',
              borderRadius: '10px',
              cursor: 'pointer',
              fontWeight: '600',
              fontSize: '13px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#e55a1a';
              e.currentTarget.style.transform = 'scale(1.02)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#ee6521';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            🖨️ Print
          </button>
          <button
            onClick={onClose}
            style={{
              padding: '10px 24px',
              backgroundColor: '#6b7280',
              color: '#fff',
              border: 'none',
              borderRadius: '10px',
              cursor: 'pointer',
              fontWeight: '600',
              fontSize: '13px',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#4b5563';
              e.currentTarget.style.transform = 'scale(1.02)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#6b7280';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvoicePopup;